module.exports = require("promise-socket");